import controller from './documents-list.controller';
import template from './documents-list.view.html';

let DocumentsListComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default DocumentsListComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/documents-list/documents-list.component.js
 **/